import { useProduct } from '~/modules/product/composables/useProduct';

type FormattedUrlTemplate = {
  swatchUrlTemplate: string;
  productUrlTemplate: string;
  videoUrlTemplate: string;
  videoPosterUrlTemplate: string;
};

export default function useUrlTemplate(): FormattedUrlTemplate {
  const { productData }: { productData: Product } = useProduct();

  return {
    swatchUrlTemplate: productData?.urlTemplate?.swatch ?? '',
    productUrlTemplate: productData?.urlTemplate?.product ?? '',
    videoUrlTemplate: productData?.urlTemplate?.video ?? '',
    videoPosterUrlTemplate: productData?.urlTemplate?.videoPoster ?? '',
  };
}
